module.exports = __webpack_public_path__ + "img/primary_data.42372222.svg";